import { generateClient } from 'aws-amplify/api';
import { newTimesheet } from "../graphql/customQueries";

const client = generateClient();

const createTimesheet = async ({ id, date, customerId, locationId, timeEntries, foremanId, userId }) => {
    const { data } = await client.graphql({
        query: newTimesheet,
        variables: {
            input: {
                id,
                date,
                timeEntries: {
                    items: timeEntries?.items?.map(({ id, crewMemberId, customerId, scopeId, hours, isApproved, status, syncStatusMessage }) => ({
                        id,
                        scopeId,
                        hours,
                        isApproved,
                        crewMemberId,
                        customerId,
                        status,
                        syncStatusMessage,
                    })),
                },

                foremanId,
                customerId,
                locationId,
                userId,
            },
        },
    });
    return data.newTimesheet;
};

export default createTimesheet;
